var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', {
    attrs: {
      "title": "프로그램 참여 신청",
      "fullscreen": "",
      "persistent": "",
      "width": "1080",
      "maxWidth": "95%",
      "needsLogin": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on,
          loading: _vm.loading
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-layout', {
    staticClass: "bottom-sheet__contents h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_vm.loading ? [_c('v-overlay', {
    attrs: {
      "absolute": "",
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": "5",
      "color": "primary"
    }
  })], 1)] : [_vm.step == _vm.STEPS.FINISH.value ? [_c('v-sheet', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('i', {
    staticClass: "icon icon-check mb-20 mb-lg-40"
  }), _c('v-sheet', {
    staticClass: "text-center mb-20 mb-lg-40"
  }, [_c('h3', {
    staticClass: "tit mb-8 mb-lg-16"
  }, [_vm._v("참여신청 완료")]), _c('p', {
    staticClass: "page-text--lg grey-6--text"
  }, [_vm._v("\"" + _vm._s(_vm.program.subject) + "\" 프로그램에 대한 신청이 완료되었습니다.")])]), _c('div', {
    staticClass: "v-btn-group mt-0"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('span', [_vm._v("확인")])])], 1)], 1)] : [_c('div', {
    staticClass: "text-center mb-20 mb-lg-40"
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v("프로그램 참여 신청")])]), _c('v-sheet', {
    staticClass: "scroll-primary pr-10",
    staticStyle: {
      "flex": "0 1 auto",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, [_c('v-stepper', {
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "pa-0",
    attrs: {
      "step": _vm.STEPS.COMMON.value
    }
  }, [_c('form-common', _vm._g({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, {
    setIsTermsValid: _vm.setIsTermsValid
  }))], 1), _c('v-stepper-content', {
    staticClass: "pa-0",
    attrs: {
      "step": _vm.STEPS.RESUME.value
    }
  }, [_c('form-resume', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'form-resume', {
    hashTags: _vm.hashTags
  }, false))], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "v-btn-group"
  }, [_vm.step == _vm.STEPS.COMMON.value ? [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v(" 취소하기 ")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v(" 다음으로 ")])])] : _vm._e(), _vm.step == _vm.STEPS.RESUME.value ? [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": _vm.prev
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v(" 이전으로 ")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v(" 신청하기 ")])])] : _vm._e()], 2)]]], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }